import React, { CSSProperties } from "react";

export default function IconToken(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				fill={props.color ?? "black"}
				d="M21.1 2c.5 0 .9.4.9.91v4.54c0 .5-.4.91-.9.91h-1.83v1.82c0 .5-.4.91-.9.91h-1.82V12a1 1 0 0 1-.27.64l-1.69 1.7A6.36 6.36 0 1 1 9.67 9.4l7.14-7.14.07-.06a1 1 0 0 1 .58-.2zm-10.51 9.06a.9.9 0 0 1-.9.23 4.55 4.55 0 1 0 3.02 3.03.9.9 0 0 1 .23-.9l1.79-1.8v-1.44c0-.5.4-.9.9-.9h1.83V7.44c0-.5.4-.9.9-.9h1.82V3.82h-2.35zm-.86 4.58a1.36 1.36 0 0 1-2.72.14v-.28c.07-.7.65-1.23 1.36-1.23l.14.01c.68.07 1.22.65 1.22 1.36"
			/>
		</svg>
	);
}
